import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  // Generate fake contribution data showing high activity
  // Only 10-20 random days will have no contributions
  const generateFakeData = (contributions) => {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    
    // Generate random set of 15 days that will have 0 contributions
    const totalDays = 365;
    const inactiveDays = new Set();
    while (inactiveDays.size < 15) {
      inactiveDays.add(Math.floor(Math.random() * totalDays));
    }
    
    // Create contribution data for each day
    const fakeData = [];
    for (let i = 0; i < totalDays; i++) {
      const date = new Date(oneYearAgo);
      date.setDate(date.getDate() + i);
      
      fakeData.push({
        date: date.toISOString().split('T')[0],
        count: inactiveDays.has(i) ? 0 : Math.floor(Math.random() * 15) + 5, // 5-20 contributions
        level: inactiveDays.has(i) ? 0 : Math.floor(Math.random() * 4) + 1 // 1-4 intensity level
      });
    }
    
    return fakeData;
  };

  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "white",
      }}
    >
      <h1 className="project-heading pb-4" style={{ paddingBottom: "20px" }}>
        Days We <strong className="purple">Code</strong>
      </h1>
      <GitHubCalendar
        username="AffanAhmedUsmani"
        blockSize={30}
        blockMargin={10}
        color="#c084f5"
        fontSize={20}
        transformData={generateFakeData}
      />
    </Row>
  );
}

export default Github;
